import '../../Styles/ReflectionSection.css'
const ReflectionSection = () => {
    return (
        <div className="reflection-section">
            <div className="reflection-heading">
                <h3 className="reflection-title">Refleksion</h3>
                <div className="reflection-btn-container">
                    <button className="reflection-btn">Skal vi lave en fuld analyse for dig?</button>
                </div>
            </div>
            <div className="reflection-spacer"></div>
            <div className="reflection-content">
                <div className="reflection-text">
                    <p className="reflection-question">
                        Reflekter over dine fem bedste og fem værste sager sidste måned. 
                        Stil dig selv følgende spørgsmål
                    </p>
                    <p>* Hvorfor er sagerne gået dårligt?</p>
                    <p>* Hvorfor er sagerne gået godt?</p>
                    <p>Tænk over, om du kunne have gjort noget anderledes og hvad du kunne gjort bedre. 
                       Du kan tage med i din refleksion, hvilken kunde og hvilken type af opgave det har været.</p>
                </div>
            </div>
        </div>
    );
}


export default ReflectionSection;